/** MY Identification Type — NRIC (주민등록번호) */
export const MY_NRIC_ID_TYPE_CD = 'M01004';

export function isMyNricIdType(idTypeCd: unknown): boolean {
    return String(idTypeCd ?? '').trim().toUpperCase() === MY_NRIC_ID_TYPE_CD;
}

/**
 * Malaysia NRIC/MyKad 앞 6자리(YYMMDD) → YYYY-MM-DD
 * @example 921209145494 → 1992-12-09
 */
export function extractMyNricBirthDateYmd(identificationNo: unknown): string | null {
    if (identificationNo == null || identificationNo === '') return null;
    const clean = String(identificationNo).replace(/\D/g, '');
    if (clean.length < 6) return null;

    const ic6 = clean.slice(0, 6);
    if (!/^\d{6}$/.test(ic6)) return null;

    const yy = Number.parseInt(ic6.slice(0, 2), 10);
    const mm = Number.parseInt(ic6.slice(2, 4), 10);
    const dd = Number.parseInt(ic6.slice(4, 6), 10);
    if (!Number.isFinite(yy) || mm < 1 || mm > 12 || dd < 1 || dd > 31) return null;

    const currentYy = new Date().getFullYear() % 100;
    const year = yy <= currentYy ? 2000 + yy : 1900 + yy;
    return `${year}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`;
}
